import type { ReactNode } from "react";

import { cn } from "@/modern/utils";

interface ChangelogCollapseProps {
  open: boolean;
  children: ReactNode;
  className?: string;
}

/** CSS grid 0fr/1fr collapse — animates expand and collapse without measuring height. */
export function ChangelogCollapse({
  open,
  children,
  className,
}: ChangelogCollapseProps) {
  return (
    <div
      className={cn(
        "grid transition-[grid-template-rows,opacity] duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none",
        open
          ? "pointer-events-auto grid-rows-[minmax(0,1fr)] opacity-100"
          : "pointer-events-none grid-rows-[minmax(0,0fr)] opacity-0",
        className
      )}
      aria-hidden={!open}
    >
      <div
        className={cn(
          "flex min-h-0 flex-col gap-3 overflow-hidden",
          open && "pt-3"
        )}
      >
        {children}
      </div>
    </div>
  );
}
